<form [formGroup]="formData" class="text-start">
  <div
    class="mb-3 row"
    *ngFor="let item of controlsData; let i = index; let last = last"
  >
    <div class="col-sm-12 mb-2">
      <label
        *ngIf="item.label && isQuePage"
        [for]="item.name"
        class="col-sm-12 question-label d-flex flex-wrap align-items-start"
      >
        <span class="question-number me-2">{{ i + 1 }}.</span>
        <span
          class="question-text dynamic-content title"
          [innerHtml]="item.label"
        ></span>
      </label>
      <label *ngIf="item.label && !isQuePage" class="col-sm-12" [for]="item.name">
        <span class="col-form-label title" [innerHtml]="item.label"></span>
        <span *ngIf="item.validators?.required" class="col-sm-2 fs-14"
          >&nbsp;(Required)</span
        >
      </label>

      <label *ngIf="!item.label && item.type!='hidden'" [for]="item.name" class="col-sm-12">
        <span class="col-form-label title">Enter the text</span>
        <span *ngIf="item.validators?.required" class="fs-14"
          >&nbsp;(Required)</span
        >
      </label>

      <div *ngIf="item.options?.helpText != null" class="col-sm-12">
        <span class="col-sm-2 fs-14" [innerHtml]="item.options?.helpText"></span>
      </div>
    </div>
    <div class="col-sm-12" [ngClass]="customClass">
      <input
        *ngIf="['text', 'password', 'search', 'url'].includes(item.type)"
        [placeholder]="item.placeholder ? item.placeholder : ''"
        [type]="item.type"
        [formControlName]="item.name"
        class="form-control"
        [id]="item.name"
        [name]="item.name"
        [value]="item.value"
        [(ngModel)]="item.value"
        [attr.maxlength]="item.validators.maxLength"
        (change)="modelChangeEvent($event, item)"
        aria-label="Text"
      />

      <input
        *ngIf="item.type === 'email'"
        [placeholder]="item.placeholder ? item.placeholder : ''"
        [type]="item.type"
        class="form-control"
        [id]="item.name"
        [name]="item.name"
        [value]="item.value"
        [(ngModel)]="item.value"
        [formControlName]="item.name"
        (keyup)="modelChangeEvent($event, item)"
        [readonly]="item.readonly === true"
      />
      
      <span
        *ngIf="item.type === 'email' && isInvalidEmail"
        class="error validation-color"
        >{{ "Enter a valid email. Example: email@address.com" }}</span
      >
      
      <input
        *ngIf="item.type === 'number'"
        [placeholder]="item.placeholder ? item.placeholder : ''"
        type="text"
        appNumberOnly
        [formControlName]="item.name"
        class="form-control"
        [id]="item.name"
        [name]="item.name"
        [value]="item.value"
        [ngModel]="item.value"
        [minlength]="item?.options?.minLength ?? 0"
        [maxlength]="item?.options?.maxLength ?? 250"
        pattern="[0-9]*"
        (ngModelChange)="modelChangeEvent($event, item)"
        aria-label="Number"
      />

      <input
        *ngIf="item.type === 'currency'"
        [placeholder]="item.placeholder ? item.placeholder : ''"
        type="text"
        appCurrency
        maxDigits="9"
        [formControlName]="item.name"
        class="form-control"
        [id]="item.name"
        [name]="item.name"
        [value]="item.value"
        [ngModel]="item.value"
        [minlength]="item?.options?.minLength ?? 0"
        [maxlength]="item?.options?.maxLength ?? 250"
        (ngModelChange)="modelChangeEvent($event, item)"
        aria-label="Currency"
        autocomplete="off"
      />

      <input
        *ngIf="item.type === 'zip'"
        [placeholder]="item.placeholder ? item.placeholder : ''"
        type="text"
        appZip
        [formControlName]="item.name"
        class="form-control"
        [id]="item.name"
        [name]="item.name"
        [(ngModel)]="item.value"
        (ngModelChange)="modelChangeEvent($event, item)"
        aria-label="Zip"
        #Zip
      />

      <span *ngIf="item.type === 'zip' && formData.get(item.name)?.invalid && formData.get(item.name)?.touched" class="error validation-color">{{'Not valid, use 5 or 9 digits or numbers in this format 12345-1234.'}}</span>

      <input
        *ngIf="item.type === 'ssn'"
        [placeholder]="item.placeholder ? item.placeholder : ''"
        type="text"
        appSsn
        [formControlName]="item.name"
        [(ngModel)]="item.value"
        (ngModelChange)="modelChangeEvent($event, item)"
        class="form-control"
        [id]="item.name"
        [name]="item.name"
        aria-label="ssn"
      />

      <span *ngIf="item.type === 'ssn' && formData.get(item.name)?.invalid && (formData.get(item.name)?.dirty || formData.get(item.name)?.touched)" class="error validation-color"> Not valid, use 9 digits in format 111-22-3333 </span>

      <input
        *ngIf="item.type === 'fax'"
        [placeholder]="item.placeholder ? item.placeholder : ''"
        type="text"
        [formControlName]="item.name"
        class="form-control"
        [id]="item.name"
        [name]="item.name"
        [value]="item.value"
        [(ngModel)]="item.value"
        (keyup)="modelChangeEvent($event, item)"
        aria-label="fax"
        #Fax
      />

      <span *ngIf="item.type === 'fax' && isInvalidFax" class="error validation-color">{{'Not valid, enter 10-digit number or use format 999-999-9999.'}}</span>

      <span *ngIf="item.type === 'date'" class="dateFieldOnlineReferrals">
        <p-calendar
          placeholder="MM/DD/YYYY"
          [formControlName]="item.name"
          [id]="item.name"
          [name]="item.name"
          [(ngModel)]="item.value"
          [minDate]="item.options.min"
          [maxDate]="item.options.max"
          (input)="formatDateToMMDDYYYY($event, item); onDateInput($event);modelChangeEvent($event, item)"
          (onClearClick)="formatDateToMMDDYYYY($event, item);modelChangeEvent($event, item)"
          (onSelect)="formatDateToMMDDYYYY($event, item);modelChangeEvent($event, item)"
          [showButtonBar]="true"
          [showIcon]="true"
          [attr.required]="item.validators.required"
          (click)="onCalendarClick()"
          inputStyleClass="form-control"
          [showOnFocus]="false"
          [attr.aria-expanded]="isCalendarOpen ? 'true' : 'false'"
          (onShow)="isCalendarOpen = true"
          (onHide)="isCalendarOpen = false"
        ></p-calendar>
        <span [id]="item.name+'_Error'" style="color: red;"></span>
    </span>

      <input
        *ngIf="item.type === 'phone'"
        type="tel"
        [formControlName]="item.name"
        class="form-control"
        [id]="item.name"
        [name]="item.name"
        [value]="item.value"
        [ngModel]="item.value"
        (ngModelChange)="modelChangeEvent($event, item)"
        aria-label="Phone"
      />

<select
        *ngIf="item.type === 'select'"
        [ngClass]="controlWidth ? 'form-select width45p' : 'form-select'"
        [formControlName]="item.name"
        aria-label="Default select example"
        [id]="item.name"
        [(ngModel)]="item.value"
        (change)="modelChangeEvent($event, item)"
        [name]="item.name"
      >
        <option value="" disabled selected>Select an option</option>
        <option [value]="option.value" *ngFor="let option of item.options">
          {{ option.key }}
        </option>
      </select>


      <textarea
        *ngIf="item.type === 'textarea'"
        class="form-control"
        [placeholder]="item.placeholder ? item.placeholder : ''"
        [formControlName]="item.name"
        [id]="item.name"
        [name]="item.name"
        [(ngModel)]="item.value"
        (ngModelChange)="modelChangeEvent($event, item)"
        [maxlength]="
          item.validators.maxLength ? item.validators.maxLength : null
        "
        [cols]="textAreaCol"
        [rows]="textAreaRows"
        aria-label="textArea"
      ></textarea>
      <span
        class="fs-14" [ngClass]="textAreaCounterPositionClass"
        *ngIf="item.type === 'textarea' && item?.options.showCount"
        style="padding-top: 3px;"
        >Character space remaining: {{ item.options.count | number }}</span
      >

      <input
        *ngIf="item.type=='hidden'"
        type="hidden"
        [formControlName]="item.name"
        class="form-control"
        [id]="item.name"
        [name]="item.name"
        [value]="item.value"
        [(ngModel)]="item.value"
        (change)="modelChangeEvent($event, item)"
        aria-label="Text"
      />
    </div>
    <div class="col-sm-2">
      <span class="fs-14" *ngIf="item.helperText">{{ item.helperText }}</span>
    </div>
    <hr class="mt-4" *ngIf="isQuePage" />
  </div>
</form>
